import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom';
import qs from 'qs';
import buscarFechamentoCaixaAgencia from '../../../actions/fechamento-caixa/agencia/buscarFechamentoCaixaAgencia';
import { arredondamentoPadrao, formatarReal, realParaNumber } from '../../../util/numberUtil';

const PRINT_STYLES = `
  @media print {
    @page {
      margin: 0;
      size: A4 portrait;
    }

    body {
      margin: 0 !important;
      padding: 0 !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    /* Esconde sidebar, overlay e header */
    .vx-sidebar,
    .vx-sidebar-overlay,
    .vx-content-wrapper > div:first-child,
    #printPageButton {
      display: none !important;
    }

    /* Remove padding do shell (sidebar) */
    .vx-shell {
      padding-left: 0 !important;
    }

    /* Zera margens do conteúdo */
    .vx-main,
    .vx-content-wrapper,
    .container-fluid,
    .animated,
    .fadeIn {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    .grid.invoice {
      margin: 0 !important;
      padding: 5mm 6mm !important;
      border: none !important;
      box-shadow: none !important;
    }

    /* Grid de duas colunas no print */
    .fc-totais-row {
      display: flex !important;
      flex-wrap: nowrap !important;
      gap: 0 !important;
      margin: 0 !important;
    }

    .fc-totais-col {
      width: 50% !important;
      padding: 0 2mm !important;
      box-sizing: border-box !important;
    }

    /* Tabelas */
    table {
      font-size: 7.5pt !important;
      width: 100% !important;
      border-collapse: collapse !important;
      page-break-inside: auto !important;
    }

    thead { display: table-header-group !important; }
    tfoot { display: table-footer-group !important; }
    tr { page-break-inside: avoid !important; }

    th, td {
      padding: 2px 3px !important;
      font-size: 7.5pt !important;
    }

    h1.fc-titulo {
      font-size: 13pt !important;
      margin: 0 0 4mm 0 !important;
      text-align: center !important;
    }

    .fc-header {
      font-size: 8pt !important;
      margin-bottom: 3mm !important;
    }

    .fc-header strong {
      font-size: 8pt !important;
    }

    .fc-vendedor-bloco {
      border: 1px solid #dee2e6 !important;
      padding: 2mm !important;
      margin-bottom: 3mm !important;
    }

    .fc-assinatura {
      margin-top: 10mm !important;
    }

    .fc-table-wrap {
      overflow: visible !important;
    }

    .fc-section {
      margin-top: 3mm !important;
    }
  }
`;

export class PainelDetalhamentoFechamentoCaixaAgencia extends React.Component {
  constructor (props) {
    super(props);
    this.componentRef = React.createRef();
  }

  imprimir () {
    window.print();
  }

  componentDidMount () {
    if (this.props.empresaSelecionada.id) {
      const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
      if (parametros.fechamento) {
        this.props.buscarFechamentoCaixaAgencia(this.props.empresaSelecionada.id, parametros.fechamento);
      }
    } else {
      this.props.history.push('/painel-fechamento-caixa')
    }
  }

  exbirLinhaTotal (titulo, valor) {
    return (
      <tr key={titulo}>
        <td style={{ fontSize: '0.78rem', padding: '3px 6px' }}>{titulo}</td>
        <td style={{ fontSize: '0.78rem', padding: '3px 6px', textAlign: 'right', whiteSpace: 'nowrap' }}>
          {arredondamentoPadrao(realParaNumber(valor)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
        </td>
      </tr>
    );
  }

  exibirHistoricos () {
    if (this.props.fechamentoCaixa.historicos && this.props.fechamentoCaixa.historicos.length) {
      return (
        <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
          <table className="table table-sm table-striped table-bordered text-center">
            <thead className="thead-light">
              <tr>
                <td colSpan={4}><strong>Movimentações do caixa</strong></td>
              </tr>
              <tr>
                <th scope="col">Data e Hora</th>
                <th scope="col">Situação</th>
                <th scope="col">Usuário</th>
                <th scope="col">Observação</th>
              </tr>
            </thead>
            <tbody>
              {this.props.fechamentoCaixa.historicos.map(historico => (
                <tr key={`historico-${historico.dataHora}`}>
                  <td>{historico.dataHora}</td>
                  <td>{historico.descricaoSituacao}</td>
                  <td>{historico.nomeUsuario}</td>
                  <td>{historico.observacao}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }

  exibirSinalSubtracao (situacao, valor) {
    if (['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(situacao) && realParaNumber(valor) > 0) {
      return ' -';
    }
  }

  exibirValorNegativo (reservas, reservaCorrente, origem) {
    let valor = 'R$ 0.00';
    reservas.filter(f => f.situacao === 'Aprovado').forEach(reserva => {
      reserva.reservas.forEach(reserva2 => {
        if (reserva2.id === reservaCorrente.id) {
          valor = origem === 'I' ? `- R$${reserva2.impostoRetido}` : `- R$${reserva2.comissao}`;
        }
      })
    });
    return valor === '- R$0.00' ? 'R$0.00' : valor;
  }

  exibirValorNegativoImposto (valor) {
    return valor > 0 ? <span>-{formatarReal(valor)}</span> : <span>R$0.00</span>
  }

  exibirValorImpostoRetidoAprovadas (reservas, reservaCorrente) {
    let valor = formatarReal(reservaCorrente.impostoRetido);
    reservas.filter(f => f.situacao === 'Cancelado').forEach(reserva => {
      reserva.reservas.forEach(reserva2 => {
        if (reserva2.id === reservaCorrente.id &&
          reservaCorrente.idRemarcada !== null &&
          reservaCorrente.custoRemarcacao === null) {
          valor = 'R$0,00';
        }
      })
    });
    return valor;
  }

  exbibirReservas (fechamento, situacoes, titulo) {
    if (fechamento.detalhamentoFechamentoCaixaUsuarioDtos) {
      const detalhamentosUsuarios = fechamento.detalhamentoFechamentoCaixaUsuarioDtos.filter(f => f.reservas !== null && situacoes.includes(f.situacao));
      if (detalhamentosUsuarios.length > 0) {
        const temCancelado = situacoes.includes('Cancelado') || situacoes.includes('Cancelado/Reembolso Efetuado');
        return (
          <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="table table-sm table-striped table-bordered text-center">
              <thead className="thead-light">
                <tr>
                  <td colSpan={temCancelado ? 10 : 9}><strong>{titulo}</strong></td>
                </tr>
                <tr>
                  <th scope="col">Pedido</th>
                  <th scope="col">Passageiro</th>
                  <th scope="col">Situação</th>
                  <th scope="col">Poltrona</th>
                  <th scope="col">Pagamento</th>
                  <th scope="col">VL Imposto</th>
                  <th scope="col">VL Comissão</th>
                  <th scope="col">VL Pedágio</th>
                  {temCancelado ? <th scope="col">Vl. Estorno</th> : null}
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              <tbody>
                {detalhamentosUsuarios.map(detalhamento =>
                  detalhamento.reservas.map(reserva => (
                    <tr key={`reserva-${reserva.id}`}>
                      <td>{reserva.pedidoId}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{reserva.passageiroDto.nome}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{detalhamento.situacao}</td>
                      <td>{reserva.numeroPoltrona}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{reserva.descricaoFormasPagamento}</td>
                      <td>
                        {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(detalhamento.situacao)
                          ? this.exibirValorNegativoImposto(reserva.estornoImpostoRetido)
                          : <span>{this.exibirValorImpostoRetidoAprovadas(detalhamentosUsuarios, reserva)}</span>}
                      </td>
                      <td>
                        {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(detalhamento.situacao)
                          ? this.exibirValorNegativo(detalhamentosUsuarios, reserva, 'C')
                          : <span>{formatarReal(reserva.comissao)}</span>}
                      </td>
                      <td>
                        {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(detalhamento.situacao)
                          ? this.exibirValorNegativo(detalhamentosUsuarios, reserva, 'C')
                          : <span>{formatarReal(reserva.pedagio)}</span>}
                      </td>
                      {temCancelado
                        ? <td><span>{['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(detalhamento.situacao) ? formatarReal(reserva.valorEstorno) : '-'}</span></td>
                        : null}
                      <td>
                        {reserva.seRemarcacao && !['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(detalhamento.situacao)
                          ? <span>{this.exibirSinalSubtracao(detalhamento.situacao, reserva.custoRemarcacao)}{formatarReal(reserva.custoRemarcacao)}</span>
                          : <span>{this.exibirSinalSubtracao(detalhamento.situacao, reserva.valorTotalReserva)}{formatarReal(reserva.valorTotalReserva)}</span>}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              {situacoes.includes('Aprovado')
                ? <tfoot>
                    <tr>
                      <td colSpan={5}><strong>TOTAIS</strong></td>
                      <td><span>{formatarReal(fechamento.totalImpostoRetido)}</span></td>
                      <td>{formatarReal(fechamento.totalComissao)}</td>
                      <td />
                      {temCancelado ? <td /> : null}
                      <td>{formatarReal(fechamento.valorTotal)}</td>
                    </tr>
                  </tfoot>
                : null}
            </table>
          </div>
        );
      }
      return null;
    }
    return null;
  }

  exbibirEncomendas (fechamento, situacoes, titulo) {
    if (fechamento.detalhamentoFechamentoCaixaUsuarioDtos) {
      const detalhamentosUsuarios = fechamento.detalhamentoFechamentoCaixaUsuarioDtos.filter(f => f.encomendas !== null && situacoes.includes(f.situacao));
      if (detalhamentosUsuarios.length > 0) {
        return (
          <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="table table-sm table-striped table-bordered text-center">
              <thead className="thead-light">
                <tr>
                  <td colSpan={8}><strong>{titulo}</strong></td>
                </tr>
                <tr>
                  <th scope="col">Pedido</th>
                  <th scope="col">Remetente</th>
                  <th scope="col">Situação</th>
                  <th scope="col">Pagamento</th>
                  <th scope="col">Imposto retido</th>
                  <th scope="col">Comissão</th>
                  <th scope="col">Vl. Estorno</th>
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              <tbody>
                {detalhamentosUsuarios.map(detalhamento =>
                  detalhamento.encomendas.map(encomenda => (
                    <tr key={`encomenda-${encomenda.id}`}>
                      <td>{encomenda.idPedido}</td>
                      <td>{encomenda.remetente.nome}</td>
                      <td>{detalhamento.situacao}</td>
                      <td>{encomenda.descricaoFormasPagamento}</td>
                      <td>
                        {detalhamento.situacao === 'Cancelado' ? 'R$ 0,00' : <span>{formatarReal(encomenda.impostoRetido)}</span>}
                      </td>
                      <td>
                        {detalhamento.situacao === 'Cancelado' ? 'R$ 0,00' : <span>{formatarReal(encomenda.comissao)}</span>}
                      </td>
                      <td>
                        <span>{detalhamento.situacao === 'Cancelado' ? formatarReal(encomenda.valor) : '-'}</span>
                      </td>
                      <td>
                        {detalhamento.situacao === 'Cancelado' ? '-' : ''}
                        <span>{formatarReal(encomenda.valor)}</span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              {situacoes.includes('Aprovado')
                ? <tfoot>
                    <tr>
                      <td colSpan={4}><strong>TOTAIS</strong></td>
                      <td><span>{formatarReal(fechamento.totalImpostoRetidoEncomenda)}</span></td>
                      <td>{formatarReal(fechamento.totalComissaoEncomenda)}</td>
                      <td />
                      <td>{formatarReal(fechamento.valorTotalEncomenda)}</td>
                    </tr>
                  </tfoot>
                : null}
            </table>
          </div>
        );
      }
      return null;
    }
    return null;
  }

  exbibirFechamento () {
    if (this.props.fechamentoCaixa.detalhamento) {
      const fechamentos = this.props.fechamentoCaixa.detalhamento;
      if (fechamentos.length) {
        return fechamentos.map(fechamento => (
          <div
            key={fechamento.nomeVendedor}
            className="fc-vendedor-bloco"
            style={{
              marginTop: '12px',
              padding: '10px',
              border: '1px solid #dee2e6',
              borderRadius: '4px'
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '8px',
              padding: '4px 8px',
              background: '#f8f9fa',
              borderRadius: '3px',
              fontSize: '0.85rem'
            }}>
              <strong>Vendedor:&nbsp;</strong>{fechamento.nomeVendedor}
            </div>
            {this.exbibirReservas(fechamento, ['Em aberto', 'Em aberto/Reembolso Solicitado', 'Remarcada'], 'Reservas Abertas/Remarcadas')}
            {this.exbibirReservas(fechamento, ['Cancelado', 'Cancelado/Reembolso Efetuado', 'Aprovado'], 'Reservas Canceladas/Aprovadas')}
            {this.exbibirEncomendas(fechamento, ['Cancelado', 'Aprovado'], 'Encomendas Canceladas/Aprovadas')}
            {this.exbibirEncomendas(fechamento, ['Em aberto', 'Remarcada'], 'Encomendas Abertas/Remarcadas')}
          </div>
        ));
      }
      return null;
    }
  }

  exibir () {
    const { fechamentoCaixa, empresaSelecionada } = this.props;
    return (
      <React.Fragment>
        {/* Cabeçalho */}
        <div className="fc-header" style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '4px',
          marginBottom: '12px',
          fontSize: '0.85rem'
        }}>
          <strong style={{ flex: '1 1 auto' }}>Empresa: {empresaSelecionada.nomeFantasia}</strong>
          <span style={{ flex: '1 1 auto', textAlign: 'center' }}>Agência: <strong>{fechamentoCaixa.nomeAgencia}</strong></span>
          <span style={{ flex: '0 0 auto', whiteSpace: 'nowrap' }}>Data: <strong>{fechamentoCaixa.dataFechamento}</strong></span>
        </div>
        <hr style={{ margin: '0 0 10px 0' }} />

        {/* Totais — duas colunas */}
        <div className="fc-totais-row" style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '0',
          marginBottom: '8px'
        }}>
          <div className="fc-totais-col" style={{ flex: '1 1 280px', overflowX: 'auto' }}>
            <table className="table table-sm table-bordered" style={{ marginBottom: 0 }}>
              <tbody>
                {this.exbirLinhaTotal('(+) Total Tx de Serviço', fechamentoCaixa.totais.totalTaxaServico)}
                {this.exbirLinhaTotal('(+) Total Tx de Pedágio', fechamentoCaixa.totais.totalPedagio)}
                {this.exbirLinhaTotal('(+) Total adiantamento baixado', fechamentoCaixa.totais.totalAdiantamentoBaixado)}
                {this.exbirLinhaTotal('(-) Total adiantamento lançado', fechamentoCaixa.totais.totalAdiantamentoLancado)}
                {this.exbirLinhaTotal('(-) Total despesas', fechamentoCaixa.totais.totalDespesas)}
                {this.exbirLinhaTotal('(-) Total Lançamentos a receber', fechamentoCaixa.totais.totalLancamentoAReceber)}
                {this.exbirLinhaTotal('(-) Total imposto retido', fechamentoCaixa.totais.totalImpostoRetido)}
                {this.exbirLinhaTotal('(-) Total seguro e imposto retido', fechamentoCaixa.totais.totalTarifaSeguroImpostoRetido)}
                {this.exbirLinhaTotal('(+) Total de vendas', fechamentoCaixa.totais.totalVendas)}
              </tbody>
            </table>
          </div>
          <div className="fc-totais-col" style={{ flex: '1 1 280px', overflowX: 'auto' }}>
            <table className="table table-sm table-bordered" style={{ marginBottom: 0 }}>
              <tbody>
                {this.exbirLinhaTotal('(-) Total recebido cartão', fechamentoCaixa.totais.totalRecebidoCartao)}
                {this.exbirLinhaTotal('(-) Total de cancelamentos', fechamentoCaixa.totais.totalCancelamento)}
                {this.exbirLinhaTotal('(+) Total recebido cartão no site', fechamentoCaixa.totais.totalRecebidoCartaoSite)}
                {this.exbirLinhaTotal('(+) Total de residual de cancelamentos', fechamentoCaixa.totais.totalCustoCancelamento)}
                {this.exbirLinhaTotal('(=) Total excesso bagagem', fechamentoCaixa.totais.totalExcessoBagagem)}
                {this.exbirLinhaTotal('(-) Total comissão', fechamentoCaixa.totais.totalComissao)}
                {this.exbirLinhaTotal('(-) Total comissão Reimpressão', fechamentoCaixa.totais.totalReimpressaoRecibo)}
                {this.exbirLinhaTotal('(-) Total comissão Seguro', fechamentoCaixa.totais.totalComissaoSeguro)}
                {this.exbirLinhaTotal('( Informativo ) Total desconto', fechamentoCaixa.totais.totalDesconto)}
                {this.exbirLinhaTotal('(=) Total Tx de Embaque CEA', fechamentoCaixa.totais.totalTaxaEmbarqueCEA)}
                {this.exbirLinhaTotal('(=) Total do deposito', fechamentoCaixa.totais.totalDeposito)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Detalhamento por vendedor */}
        {this.exbibirFechamento()}

        {/* Histórico */}
        {this.exibirHistoricos()}

        {/* Assinatura */}
        <div className="fc-assinatura text-center" style={{ marginTop: '48px' }}>
          <p style={{ textDecoration: 'overline', display: 'inline-block', minWidth: '300px' }}>
            Assinatura do Responsável (Por Extenso)
          </p>
        </div>
      </React.Fragment>
    );
  }

  exibirBotoes () {
    return (
      <div className="d-flex justify-content-center flex-wrap my-2" id="printPageButton">
        <Link to="/painel-fechamento-caixa-agencia">
          <button className="btn btn-sm btn-laranja mx-1">Concluir</button>
        </Link>
        <button
          className="btn btn-sm btn-laranja mx-1"
          onClick={() => this.imprimir()}
        >
          <i className="material-icons mr-1" style={{ fontSize: '16px', verticalAlign: 'middle' }}>print</i>
          Imprimir / Salvar PDF
        </button>
      </div>
    );
  }

  render () {
    if (this.props.fechamentoCaixa) {
      return (
        <React.Fragment>
          <style dangerouslySetInnerHTML={{ __html: PRINT_STYLES }} />
          <div className="grid invoice" style={{ padding: '8px' }}>
            {this.exibirBotoes()}
            <div
              ref={this.componentRef}
              className="grid-body"
              id="cupom-encomenda"
              style={{ fontSize: '14px', fontWeight: 'bold' }}
            >
              <h1 className="fc-titulo text-center mb-3" style={{ fontSize: '1.4rem' }}>
                Fechamento de caixa Agência
              </h1>
              {this.exibir()}
            </div>
            {this.exibirBotoes()}
          </div>
        </React.Fragment>
      );
    }
    return '';
  }
}

export const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
  fechamentoCaixa: state.fechamentoCaixa
});

export default withRouter(connect(mapStateToProps, { buscarFechamentoCaixaAgencia })(PainelDetalhamentoFechamentoCaixaAgencia));
